exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".ebx-banner__link{display:block;width:100%}.ebx-banner__img{width:100%}", ""]);
